
import React from "react";
import { Control } from "react-hook-form";
import LinkableCheckbox from "../common/LinkableCheckbox";

interface TermsCheckboxProps {
  control: Control<any>;
}

const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ control }) => {
  return (
    <LinkableCheckbox
      control={control}
      name="agreeToTerms"
      className="mt-4"
      label="I agree to the"
      links={[
        {
          text: "Terms of Service",
          href: "/terms-of-use"
        },
        {
          text: "Privacy Policy",
          href: "/privacy-policy"
        }
      ]}
    />
  );
};

export default TermsCheckbox;
